<template>
    <div :class="wrapClass">
        <Button v-if="liked" :disabled="isLoading" aria-label="Fjern bil fra favoritliste" @click="toggleFavorite"
            class="p-button-rounded" :class="buttonClass" icon="pi pi-heart-fill"></Button>
        <Button v-else :disabled="isLoading" aria-label="Tilføj bil til favoritliste" @click="toggleFavorite"
            class="p-button-rounded" :class="buttonClass" icon="pi pi-heart"></Button>
        <UserSignupPopup :visible="showPopup"></UserSignupPopup>
    </div>
</template>
<script>

import Button from 'primevue/button';
import UserSignupPopup from './userSignupPopup';
import VueHelpers from './../vueHelpers';

export default {
    name: "favoriteCarButton",
    props: ["vehicleId", "vehicleNodeId", "preLiked", "wrapClass", "buttonClass"],
    components: {
        Button,
        UserSignupPopup
    },
    data() {
        return {
            dictionary: [],
            liked: false,
            lastAction: null,
            isLoading: false,
            showPopup: false
        };
    },
    created() {
        const vm = this;

        vm.lastAction = VueHelpers.getTimestampInSeconds();
        vm.liked = vm.preLiked;
    },
    methods: {
        toggleFavorite() {
            const vm = this;
            vm.showPopup = false;

            if (VueHelpers.getTimeDifferenceInSeconds(vm.lastAction) > 1) {
                vm.toggleSpinner(true);
                fetch('/umbraco/api/favoritesApi/ToggleFavorite', {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json",
                        "RequestVerificationToken": VueHelpers.getAntiForgeryToken()
                    },
                    body: JSON.stringify({ vehicleId: vm.vehicleId, vehicleNodeId: vm.vehicleNodeId }),
                }).then((response) => {
                    if (response.status == 200) {
                        vm.liked = true;
                        vm.toggleSpinner(false);

                        return response;
                    }
                    const error = new Error("");
                    error.status = response.status;
                    throw error;
                }).catch((error) => {
                    if (error.status == 404) {
                        vm.liked = false;
                    } else if (error.status == 401) {
                        vm.liked = false;
                        vm.showPopup = true;
                    } else {
                        console.log(error);
                    }
                    vm.toggleSpinner(false);
                });

                vm.lastAction = VueHelpers.getTimestampInSeconds();
            }
        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;
            const bodyElement = document.querySelector("body");
            if (isLoading) {
                bodyElement.classList.add("is-loading");
            } else {
                bodyElement.classList.remove("is-loading");
            }
        },
    }
};
</script>
